module.exports = __webpack_public_path__ + "img/D201503_3.afbb83d7.jpg";